import { createAsyncThunk } from "@reduxjs/toolkit";
import { ColumnFiltersState } from "@tanstack/react-table";
import { Axios } from "api/axios";

export const fetchGps = createAsyncThunk(
  "gp/fetchGps",
  async ({
    page,
    pageSize,
    sort,
    order,
    search,
    filters,
  }: {
    page: number;
    pageSize: number;
    search?: string;
    sort?: string;
    order?: "asc" | "desc" | "";
    filters?: any;
  }) => {
    const params = new URLSearchParams();
    params.append("page", page.toString());
    params.append("page_size", pageSize.toString());
    if (search) params.append("search", search);
    if (sort) {
      const orderingValue = order === "desc" ? `-${sort}` : sort;
      params.append("ordering", orderingValue);
    }

    if (filters && filters.length > 0) {
      // params.append("filters", JSON.stringify(filters));
      filters.forEach(
        ({
          filterField,
          filterValue,
        }: {
          filterField: string;
          filterValue: any;
        }) => {
          if (
            filterField &&
            filterValue !== undefined &&
            filterValue !== null
          ) {
            if (typeof filterValue === "object" && filterValue !== null) {
              // filterField is expected to be either 'created_at' or 'updated_at'
              Object.entries(filterValue).forEach(([key, value]) => {
                if (value !== undefined && value !== null && value !== "") {
                  const dateKey = `${filterField}_${
                    key === "from_date" ? "from" : "to"
                  }`;
                  params.append(dateKey, String(value));
                }
              });
            } else {
              // Handle primitive values (string, number)
              if (filterField === "covered") {
                // If filterValue is "Covered", convert to true
                // If it's "Not Covered", convert to false
                console.log(
                  `filterValue: ${filterValue} filterField: ${filterField}`
                );
                const booleanValue =
                  filterValue === "covered"
                    ? true
                    : filterValue === "uncovered"
                    ? false
                    : filterValue;
                params.append(filterField, String(booleanValue));
              } else {
                params.append(filterField, filterValue);
              }
            }
          }
        }
      );
    }
    const response: any = await Axios.get(`/gp/?${params.toString()}`);
    // const response: any = await Axios.get(`/gp/`, {
    //   params: {
    //     page,
    //     page_size: pageSize,
    //     search: search || undefined,
    //     filters: filters ? JSON.stringify(filters) : undefined,
    //   },
    // });
    return {
      data: response.data.data || [],
      rowCount: response.data.count || 0,
    };
  }
);

export const fetchGpById = createAsyncThunk(
  "gp/fetchById",
  async (id: string, { rejectWithValue }) => {
    try {
      const response: any = await Axios.get(`/gp/${id}/`);
      return response;
    } catch (err: any) {
      return rejectWithValue(err.response?.data || "Failed to fetch GP by ID");
    }
  }
);

export const fetchGpByDropDown = createAsyncThunk(
  "Gp/fetchByDropDown",
  async (_, { rejectWithValue }) => {
    try {
      const response = await Axios.get(`/Gp/dropdown/`);
      return response.data;
    } catch (err: any) {
      return rejectWithValue(err.response?.data || "Failed to fetch Gp list");
    }
  }
);

export const updateGp = createAsyncThunk(
  "gp/updateGp",
  async (gpData: any, { rejectWithValue }) => {
    try {
      const response: any = await Axios.put(`/gp/${gpData.id}/update/`, gpData);
      return response;
    } catch (err: any) {
      return rejectWithValue(err.response?.data || "Failed to update GP");
    }
  }
);

export const updateStatusInGp = createAsyncThunk(
  "gp/updateStatusInGp",
  async (gpData: any, { rejectWithValue }) => {
    try {
      const payload = { is_active: gpData.is_active };
      // const response: any = await Axios.patch(
      //   `/gp/${gpData.id}/update/`,
      //   payload
      // );
      const response: any = await Axios.put(
        `/gp/is_active/${gpData.id}/`,
        payload
      );
      return response.data.data;
    } catch (err: any) {
      return rejectWithValue(
        err.response?.data || "Failed to update Status in GP"
      );
    }
  }
);

export const addGp = createAsyncThunk(
  "gp/addGp",
  async (gpData: any, { rejectWithValue }) => {
    try {
      const response: any = await Axios.post(`/gp/create/`, gpData);
      return response;
    } catch (err: any) {
      return rejectWithValue(err.response?.data || "Failed to add GP");
    }
  }
);

// export const exportGpCSV = async () => {
//   const response = await Axios.get("/gp/?export=csv", {
//     responseType: "blob",
//   });

//   return {
//     blob: response.data,
//     filename:
//       response.headers["content-disposition"]
//         ?.split("filename=")[1]
//         ?.replace(/"/g, "") || "gp.csv",
//   };
// };

// export const exportGpCSV = async ({
//   search,
//   filters,
// }: {
//   search?: string;
//   filters?: any;
// }) => {
//   const params = new URLSearchParams();

//   params.append("export", "excel");

//   if (search) params.append("search", search);

//   if (filters && filters.length > 0) {
//     filters.forEach(
//       ({
//         filterField,
//         filterValue,
//       }: {
//         filterField: string;
//         filterValue: any;
//       }) => {
//         if (filterField && filterValue !== undefined && filterValue !== null) {
//           if (typeof filterValue === "object" && filterValue !== null) {
//             Object.entries(filterValue).forEach(([key, value]) => {
//               if (value !== undefined && value !== null && value !== "") {
//                 params.append(key, String(value));
//               }
//               if (
//                 (filterValue.from_date || filterValue.to_date) &&
//                 (filterField === "created_at" || filterField === "updated_at")
//               ) {
//                 if (filterField === "created_at") {
//                   filterField = "created";
//                 } else {
//                   filterField = "updated";
//                 }
//                 params.append("filter_by", filterField);
//               }
//             });
//           } else {
//             params.append(filterField, filterValue);
//           }
//         }
//       }
//     );
//   }

//   const response = await Axios.get(`/gp/?${params.toString()}`, {
//     responseType: "blob",
//   });

//   return {
//     blob: response.data,
//     filename:
//       response.headers["content-disposition"]
//         ?.split("filename=")[1]
//         ?.replace(/"/g, "") || "gp.csv",
//   };
// };


export const exportGpCSV = async ({
  search,
  filters,
}: {
  search?: string;
  filters?: any;
}) => {
  const params = new URLSearchParams();

  params.append("export", "excel");

  if (search) params.append("search", search);

  if (filters && filters.length > 0) {
    filters.forEach(
      ({
        filterField,
        filterValue,
      }: {
        filterField: string;
        filterValue: any;
      }) => {
        if (filterField && filterValue !== undefined && filterValue !== null) {
          // Handle date filters
          if (
            typeof filterValue === "object" &&
            (filterField === "created_at" || filterField === "updated_at")
          ) {
            const prefix = filterField; // created_at or updated_at
            if (filterValue.from_date) {
              params.append(`${prefix}_from`, filterValue.from_date);
            }
            if (filterValue.to_date) {
              params.append(`${prefix}_to`, filterValue.to_date);
            }
          } else if (typeof filterValue === "object") {
            // Handle other object filters (e.g., dropdowns with value-label)
            Object.entries(filterValue).forEach(([key, value]) => {
              if (value !== undefined && value !== null && value !== "") {
                params.append(key, String(value));
              }
            });
          } else {
            // Primitive values
            params.append(filterField, filterValue);
          }
        }
      }
    );
  }

  const response = await Axios.get(`/gp/?${params.toString()}`, {
    responseType: "blob",
  });

  return {
    blob: response.data,
    filename:
      response.headers["content-disposition"]
        ?.split("filename=")[1]
        ?.replace(/"/g, "") || "gp.csv",
  };
};

